import { render, staticRenderFns } from "./new-index.vue?vue&type=template&id=4e18889e&scoped=true&"
import script from "./new-index.vue?vue&type=script&lang=ts&"
export * from "./new-index.vue?vue&type=script&lang=ts&"
import style0 from "./new-index.vue?vue&type=style&index=0&id=4e18889e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e18889e",
  null
  
)

export default component.exports